import { ISummerCampEnquiry } from '@wot/typings';

const BASE_URL = 'https://aisummercamp.worldotutor.com/api/admin/enquiries';

async function request<T>(url: string, options?: RequestInit): Promise<T> {
  const res = await fetch(url, {
    credentials: 'include',
    headers: { 'Content-type': 'application/json' },
    ...options
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || `HTTP ${res.status}`);
  }

  if (res.status === 204) return undefined as T;
  return res.json();
}

interface ListResponse {
  success: boolean;
  data: ISummerCampEnquiry[];
  pagination: { total: number; page: number; limit: number; totalPages: number };
}

const get = async (
  currentPage: number,
  resultsPerPage: number,
  filters: any,
  sortBy: any
): Promise<{ count: number; data: ISummerCampEnquiry[] }> => {
  const params = new URLSearchParams({
    limit: resultsPerPage.toString(),
    page: currentPage.toString(),
    ...filters,
    ...sortBy
  });

  const body = await request<ListResponse>(`${BASE_URL}?${params}`);

  return {
    count: body.pagination?.total || 0,
    data: body.data || []
  };
};

const getById = async (id: string): Promise<ISummerCampEnquiry> => {
  const body = await request<{ success: boolean; data: ISummerCampEnquiry }>(`${BASE_URL}/${id}`);
  return body.data;
};

const update = async (id: string, payload: Partial<ISummerCampEnquiry>): Promise<ISummerCampEnquiry> => {
  const body = await request<{ success: boolean; data: ISummerCampEnquiry }>(`${BASE_URL}/${id}`, {
    method: 'PUT',
    body: JSON.stringify(payload)
  });
  return body.data;
};

const remove = async (id: string): Promise<void> => {
  await request(`${BASE_URL}/${id}`, { method: 'DELETE' });
};

const bulkRemove = async (ids: string[]): Promise<void> => {
  await request(`${BASE_URL}?ids=${ids.join(',')}`, { method: 'DELETE' });
};

const summerCampApi = {
  get,
  getById,
  update,
  remove,
  bulkRemove
};

export default summerCampApi;
